import { useContext, useEffect } from 'react';
import AppBarContext from '../components/BusinessPortalAppBarContext';

const useInitAppBar = (
  {
    visible,
    periodSelector
  }: {
    visible: boolean;
    periodSelector: boolean;
  } = { visible: true, periodSelector: false }
) => {
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(visible);
    appBarContext.setPeriodSelector(periodSelector);
  }, [appBarContext]);
};

export default useInitAppBar;
